import React from "react";
import styles from "./event.module.css";
import StandardRewardRow from "./standard-reward-row";
import { v4 } from "uuid";
import { getUIText } from "../../../../translation";

export default function Event({ lang, event }) {
    return (
        <div className={styles["event"]}>
            <div className={styles["event-name"]}>{event.name[lang]}</div>
            <div className={styles["choice-rewards"]}>
                {event.choices.map((choice, i) => {
                    return (
                        <div className={styles["choice"]} key={v4()}>
                            {choice.name && (
                                <div className={`${styles["choice-name"]} ${i === 0 ? `${styles["success"]}` : `${styles["fail"]}`}`}>
                                    {choice.name[lang]}
                                </div>
                            )}
                            <div className={`${styles["rewards"]} ${styles["success"]}`} key={v4()}>
                                {choice.failure_rewards.length > 0 && (
                                    <div className={styles["title"]}>{getUIText(lang, "arcana.card.modal.event.success")}</div>
                                )}
                                {choice.success_rewards.map((reward) => {
                                    return <StandardRewardRow lang={lang} reward={reward} key={v4()} />;
                                })}
                            </div>
                            {choice.failure_rewards.length > 0 && (
                                <div className={`${styles["rewards"]} ${styles["fail"]}`} key={v4()}>
                                    <div className={styles["title"]}>{getUIText(lang, "arcana.card.modal.event.failed")}</div>
                                    {choice.failure_rewards.map((reward) => {
                                        return <StandardRewardRow lang={lang} reward={reward} key={v4()} />;
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
